import initialState from "./stores.value";

const storeReducer = (state = initialState, action) => {
  switch (action.type) {
    case "Set_filter_data":
      return {
        ...state,
        stores: {
          ...action.payload,
          storesCodeNameList: action.payload.stores,
        },
        apiStores: {...state.apiStores}
      };
    case "Set_store_data_api":
      return {
        ...state,
        stores: {
          ...state.stores,
        },
        apiStores: action.payload
      };
    default:
      return state;
  }
};

export default storeReducer;